export default __webpack_public_path__ + "3acf3e3.png";